export const dayPages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/rv3FJLNzpBfPFqCvALWCUi/Screenshot_20261002_225847_My_Files.jpg',
    alt: 'Portada del Método R.E.V.E.L.A.',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/euVXLWhuhFHUGB2kLFPBQY/Screenshot_20261002_225914_My_Files.jpg',
    alt: 'Índice del programa: introducción, el método y semanas 1 y 2',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/pkFoxEzToTgoQ8F3H5EppZ/Screenshot_20261002_225926_My_Files.jpg',
    alt: 'Índice del programa: semanas 3 y 4, cierre y obsequios exclusivos',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/6qinutpjf2eGUDAQrwTaZe/Screenshot_20261002_225304_My_Files.jpg',
    alt: 'Semana 1: Preparando el Terreno',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/3uDF7ucdVcP15e5uFVX7dr/Screenshot_20261002_225713_My_Files.jpg',
    alt: 'Día 1: El poder de un Nuevo Comienzo, versículo y reflexión',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/iHjGuLMYacF5fzXWzfbEup/Screenshot_20261002_225728_My_Files.jpg',
    alt: 'Aplicando el Método R.E.V.E.L.A. Día 1: Relajación, Escritura y Visualización',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/nfXHZ3xmCmJDQ3fbJ8EAXD/Screenshot_20261002_225741_My_Files.jpg',
    alt: 'Día 1: Emoción Elevada, Liberación y Acción Inspirada',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/dCKoC4fqrCA1n2odHotEgC/Screenshot_20261002_225800_My_Files.jpg',
    alt: 'Oración del Día y Declaración de Fe',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/5XoqkBc3JqD4wm43D8mdnb/Screenshot_20261002_225815_My_Files.jpg',
    alt: 'Preparación para mañana',
  },
]
